import gql from 'graphql-tag';
import {globalfunc} from '../../../../shared/GlobalFunction.js';

class GroupTypeService {
    readGroupTypeQuery(){
        var query = `
            query{
                GetGroupType{
                    group_type_id
                    group_type_name
                    active_flag
                    is_visible
                    item_group_id
                    item_group_name
                    created_at
                    last_update
                    roles {
                        roleid
                        rname
                    }
                }
            }
        `;
        return query;
    }

    async addQuery(variables){
        var query = gql`
            mutation($data: group_type_new!){
                CreateGroupType(New: $data){
                    response
                }
            }
        `;
        return await globalfunc.defaultApolloMutationDefault(query, variables)
    }

    async editQuery(variables){
        var query = gql`
            mutation($id: String!, $data: group_type_new!){
                UpdateGroupType(GroupType_Id: $id, New: $data ){
                    response
                }
            }
        `;
        return await globalfunc.defaultApolloMutationDefault(query, variables)
    }

    async deleteQuery(variables){
        var query = gql`
            mutation( $id: String! ){
                DeleteGroupType( GroupType_Id: $id ){
                    response
                }
            }
        `;
        return await globalfunc.defaultApolloMutationDefault(query, variables)
    }

    async getItemGroupQuery(){
        const query = gql`
            query{
                GetItemGroup {
                    item_group_id
                    item_group_name
                }
            }
        `;
        var result = await globalfunc.defaultApolloQueryDefault(query);
        var arrayData = [];
        if(result.data.GetItemGroup != null){
            for (let i = 0; i < result.data.GetItemGroup.length; i++) {
                var str = { 
                    value: result.data.GetItemGroup[i].item_group_id,
                    label: result.data.GetItemGroup[i].item_group_name
                }
                arrayData.push(str);
            }
        }
        return arrayData;
    }

    gridDataConverter(data){
        let array = [];
        for (let i = 0; i < data.length; i++) {
            var str = {
                roleid: data[i].roleid,
                rname: data[i].rname,
            }
            array.push(str);
        }
        return array;
    }

    gridSelector(selected, checkall, data){
        if (checkall == 'true'){
            if (selected == '') {
                var newData = data;
                return newData;
            }
            else {
                var selectedData =  selected.split(",");
                var hashMap = [];
                data.forEach(el=>{
                    hashMap[el.roleid]= el
                })
                for (let i = 0; i < selectedData.length; i++) {
                    delete hashMap[selectedData[i].toString()]
                }
                var newData = [];
                Object.keys(hashMap).forEach(el=>{
                    newData.push(hashMap[el])
                })
                return newData;
            }
        }
        else {
            if (selected == '') {
                var newData = [];
                return newData;
            }
            else {
                var selectedData =  selected.split(",");
                var hashMap = [];
                data.forEach(el=>{
                    hashMap[el.roleid]= el
                })
                var newData = [];
                for (let i = 0; i < selectedData.length; i++) {
                    newData.push(hashMap[selectedData[i].toString()])
                }
                return newData;
            }
        }
    }

    itemGridValidation(data){
        var newData = data.split(";");
        
        let array = [];
        for (let i = 0; i < newData.length; i++) {
            var str = newData[i].split("|");
            array.push(str[0]);
        }

        var isDuplicate = array.some(function(item, idx){ 
            return array.indexOf(item) != idx 
        });

        if(isDuplicate){
            return null;
        }else{
            return array.toString();
        }
    }

    selectedItemConverter(data){
        var newData = data.split(";");
        let array = [];
        for (let i = 0; i < newData.length; i++) {
            var splitData = newData[i].split("|");
            var str = {
                roleid: parseInt(splitData[0]),
                rname: splitData[1],
            }
            array.push(str);
        }

        return array;
    }
}

export default new GroupTypeService();